define("discourse/plugins/discourse-sidebar-blocks/discourse/helpers/latest-posts-category", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLatestPosts = getLatestPosts;

  function getLatestPosts(context) {
    var store = context.register.lookup('service:store');
    var filter = "c/" + context.attrs.category;
    return store.findFiltered("topicList", {
      filter: filter
    }).then(function (result) {
      return result.topic_list.topics;
    }).catch(function () {
      console.log('getting topic list failed');
      return [];
    });
  }
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/helpers/leaderboard-list", ["exports", "discourse/lib/ajax"], function (_exports, _ajax) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLeaderboardList = getLeaderboardList;

  function getLeaderboardList(context) {
    var period = context.siteSettings.sidebar_leaderboard_period;
    var count = context.siteSettings.sidebar_leaderboard_count;
    return (0, _ajax.ajax)('/directory_items.json?period=' + period + '&order=likes_received').then(function (result) {
      // console.log("Leaderboard list :", result);
      return result.directory_items.splice(0, count);
    }).catch(function () {
      // console.log('getting user list failed')
      return [];
    });
  }
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/helpers/recent-replies", ["exports", "discourse/lib/ajax"], function (_exports, _ajax) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getLatestReplies = getLatestReplies;

  function getLatestReplies(context) {
    return (0, _ajax.ajax)('/posts.json').then(function (result) {
      return result.latest_posts;
    }).catch(function () {
      console.log('getting topic list failed');
      return [];
    });
  }
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/initializers/home-sidebar", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    name: 'home-sidebar',
    initialize: function initialize() {}
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discovery"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"container\"],[8],[0,\"\\n  \"],[1,[28,\"discourse-banner\",null,[[\"user\",\"banner\"],[[24,[\"currentUser\"]],[24,[\"site\",\"banner\"]]]]],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"list-controls\"],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"container\"],[8],[0,\"\\n    \"],[1,[28,\"outlet\",[\"navigation-bar\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\\n\"],[7,\"div\",true],[11,\"class\",[29,[\"container list-container  \",[28,\"if\",[[24,[\"siteSettings\",\"sidebar_enable\"]],\"has-sidebar\"],null]]]],[8],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"row\"],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"full-width\"],[8],[0,\"\\n      \"],[1,[28,\"conditional-loading-spinner\",null,[[\"condition\"],[[24,[\"loading\"]]]]],false],[0,\"\\n      \"],[7,\"div\",true],[10,\"id\",\"header-list-area\"],[8],[0,\"\\n        \"],[1,[28,\"outlet\",[\"header-list-container\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n  \"],[7,\"div\",true],[11,\"class\",[29,[\"row \",[28,\"if\",[[24,[\"loading\"]],\"hidden\"],null]]]],[8],[0,\"\\n    \"],[7,\"div\",true],[10,\"class\",\"full-width\"],[8],[0,\"\\n      \"],[7,\"div\",true],[10,\"id\",\"list-area\"],[8],[0,\"\\n        \"],[1,[28,\"plugin-outlet\",null,[[\"name\",\"args\",\"tagName\",\"connectorTagName\"],[\"discovery-list-container-top\",[28,\"hash\",null,[[\"category\"],[[24,[\"category\"]]]]],\"span\",\"div\"]]],false],[0,\"\\n        \"],[1,[28,\"outlet\",[\"list-container\"],null],false],[0,\"\\n      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"siteSettings\",\"sidebar_enable\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"sidebar\"],[8],[0,\"\\n    \"],[1,[28,\"mount-widget\",null,[[\"widget\"],[\"sidebar-items\"]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[1,[28,\"plugin-outlet\",null,[[\"name\",\"tagName\",\"connectorTagName\"],[\"discovery-below\",\"span\",\"div\"]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/discovery"}});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-category-posts", ["exports", "discourse/widgets/widget", "discourse/plugins/discourse-sidebar-blocks/discourse/helpers/latest-posts-category", "discourse/helpers/category-link", "discourse/widgets/raw-html", "virtual-dom", "discourse/models/category"], function (_exports, _widget, _latestPostsCategory, _categoryLink, _rawHtml, _virtualDom, _category) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)("sidebar-category-posts", {
    tagName: "div.sidebar-category-posts",
    buildKey: function buildKey(attrs) {
      return "sidebar-category-posts-".concat(attrs.category);
    },
    defaultState: function defaultState() {
      return {
        loading: false
      };
    },
    buildClasses: function buildClasses(attrs) {
      var result = [];

      if (attrs.category) {
        result.push("sidebar-c-".concat(attrs.category));
      }

      return result;
    },
    refreshTopics: function refreshTopics() {
      var _this = this;

      if (this.state.loading) {
        return;
      }

      this.state.loading = true;
      this.state.topics = "empty";
      (0, _latestPostsCategory.getLatestPosts)(this).then(function (result) {
        for (var i = result.length - 1; i >= 0; i--) {
          // remove archived posts
          if (result[i].archived) {
            result.splice(i, 1);
          }
        }

        if (result.length) {
          var max = parseInt(_this.siteSettings.sidebar_num_results) - 1;

          for (var i = result.length - 1; i >= 0; i--) {
            if (i > max) {
              result.splice(i, 1);
            }
          }

          _this.state.topics = result;
        } else {
          _this.state.topics = "empty";
        }

        _this.state.loading = false;

        _this.scheduleRerender();
      });
    },
    html: function html(attrs, state) {
      var _this2 = this;

      if (!state.topics) {
        this.refreshTopics();
      }

      var result = [];

      if (state.loading) {
        result.push((0, _virtualDom.h)("div.spinner-container", (0, _virtualDom.h)("div.spinner")));
      } else if (state.topics !== "empty") {
        var category = _category.default.findBySlug(attrs.category);

        result.push((0, _virtualDom.h)("div", {
          innerHTML: (0, _categoryLink.categoryBadgeHTML)(category)
        }));
        var topicItems = state.topics.map(function (t) {
          return _this2.attach("sidebar-post-item", t);
        });
        result.push((0, _virtualDom.h)("div", [topicItems]));
      } else {
        var category = _category.default.findBySlug(attrs.category);

        result.push((0, _virtualDom.h)("div", {
          innerHTML: (0, _categoryLink.categoryBadgeHTML)(category)
        }));
        result.push((0, _virtualDom.h)("div.no-messages", "No posts in this category."));
      }

      return result;
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-custom-content", ["discourse/widgets/widget", "virtual-dom"], function (_widget, _virtualDom) {
  "use strict";

  (0, _widget.createWidget)('sidebar-custom-content', {
    tagName: 'div.sidebar-custom-content',
    html: function html(attrs) {
      return (0, _virtualDom.h)('div', {
        innerHTML: this.siteSettings.sidebar_custom_content
      });
    }
  });
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-items", ["exports", "discourse/widgets/widget", "virtual-dom"], function (_exports, _widget, _virtualDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)('sidebar-items', {
    tagName: 'div.sidebar-items',
    buildKey: function buildKey() {
      return 'sidebar-items';
    },
    html: function html(attrs, state) {
      if (!this.siteSettings.sidebar_enable || this.site.mobileView) return;
      var sidebarBlocks = this.siteSettings.sidebar_block_order.split("|");
      var result = [];
      var self = this;
      sidebarBlocks.map(function (item) {
        if (item == 'latest_replies') {
          result.push(self.attach('sidebar-latest-replies'));
        } else if (item == 'custom_html') {
          result.push(self.attach('sidebar-custom-content'));
        } else if (item == 'leaderboard') {
          result.push(self.attach('sidebar-leaderboard'));
        } else {
          result.push(self.attach('sidebar-category-posts', {
            category: item
          }));
        }
      });
      return result;
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-latest-replies", ["exports", "discourse/widgets/widget", "discourse/plugins/discourse-sidebar-blocks/discourse/helpers/recent-replies", "virtual-dom"], function (_exports, _widget, _recentReplies, _virtualDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)('sidebar-latest-replies', {
    tagName: 'div.sidebar-latest-replies',
    buildKey: function buildKey(attrs) {
      return 'sidebar-latest-replies';
    },
    defaultState: function defaultState() {
      return {
        loading: false
      };
    },
    refreshPosts: function refreshPosts() {
      var _this = this;

      if (this.state.loading) {
        return;
      }

      this.state.loading = true;
      this.state.posts = 'empty';
      (0, _recentReplies.getLatestReplies)(this).then(function (result) {
        if (result.length) {
          for (var i = result.length - 1; i >= 0; i--) {
            // remove first post in a topic (not a reply)
            // remove any "post" that is merely an action
            // remove hidden posts
            if (result[i].post_number < 2 || result[i].action_code != undefined || result[i].hidden) {
              result.splice(i, 1);
            }
          }

          for (var i = result.length - 1; i >= 0; i--) {
            // limit to 5 max
            if (i > 4) {
              result.splice(i, 1);
            }
          }

          _this.state.posts = result;
        } else {
          _this.state.posts = 'empty';
        }

        _this.state.loading = false;

        _this.scheduleRerender();
      });
    },
    html: function html(attrs, state) {
      var _this2 = this;

      var messageBus = this.register.lookup('message-bus:main');
      messageBus.subscribe("/latest", function (data) {
        _this2.refreshPosts();
      });

      if (!state.posts) {
        this.refreshPosts();
      }

      var result = [];

      if (state.loading) {
        result.push((0, _virtualDom.h)('div.spinner-container', (0, _virtualDom.h)('div.spinner')));
      } else if (state.posts !== 'empty') {
        result.push((0, _virtualDom.h)('h3.sidebar-heading', I18n.t('sidebar_blocks.recent_replies')));
        var replies = state.posts.map(function (t) {
          return _this2.attach('sidebar-reply-item', t);
        });
        result.push(replies);
      } else {
        result.push((0, _virtualDom.h)('div.no-messages', 'No recent replies.'));
      }

      return result;
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-leaderboard", ["discourse/widgets/widget", "virtual-dom", "discourse/plugins/discourse-sidebar-blocks/discourse/helpers/leaderboard-list", "discourse-common/lib/icon-library"], function (_widget, _virtualDom, _leaderboardList, _iconLibrary) {
  "use strict";

  (0, _widget.createWidget)('sidebar-leaderboard', {
    tagName: 'div.sidebar-leaderboard',
    buildKey: function buildKey(attrs) {
      return 'sidebar-leaderboard';
    },
    defaultState: function defaultState() {
      return {
        loading: false
      };
    },
    refreshUsers: function refreshUsers() {
      var _this = this;

      if (this.state.loading) {
        return;
      }

      this.state.loading = true;
      this.state.users = 'empty';
      (0, _leaderboardList.getLeaderboardList)(this).then(function (result) {
        // console.log("refreshUsers List : ", result);
        if (result.length) {
          _this.state.users = result;
        } else {
          _this.state.users = 'empty';
        }

        _this.state.loading = false;

        _this.scheduleRerender();
      });
    },
    leaderboardRow: function leaderboardRow(user) {
      // console.log("user : ", user);
      return (0, _virtualDom.h)("tr", {
        "attributes": {
          "data-user-card": user.user.username
        }
      }, [(0, _virtualDom.h)('td', [(0, _virtualDom.h)('div.useravatar', this.attach('topic-participant', user.user)), (0, _virtualDom.h)('div.username.trigger-data-card', user.user.username)]), (0, _virtualDom.h)('td', (0, _virtualDom.h)('span.points', user.likes_received + ''))]);
    },
    leaderboardHeader: function leaderboardHeader() {
      return (0, _virtualDom.h)('h3.sidebar-heading', (0, _virtualDom.h)('a', {
        'attributes': {
          'href': '/u',
          'title': 'Leaderboard'
        }
      }, 'Leaderboard'));
    },
    html: function html(attrs, state) {
      var _this2 = this;

      if (!state.users) {
        this.refreshUsers();
      }

      var result = [];

      if (state.loading) {
        result.push((0, _virtualDom.h)('div.spinner-container', (0, _virtualDom.h)('div.spinner')));
      } else if (state.users !== 'empty') {
        result.push(this.leaderboardHeader());
        var users = state.users.map(function (user) {
          return _this2.leaderboardRow(user);
        });
        result.push((0, _virtualDom.h)("div.directory", (0, _virtualDom.h)("table", [(0, _virtualDom.h)("tbody", [(0, _virtualDom.h)("tr", [(0, _virtualDom.h)("th", 'User'), (0, _virtualDom.h)("th", [(0, _iconLibrary.iconNode)('heart'), (0, _virtualDom.h)('span', 'Received')])]), users])])));
      } else {
        result.push((0, _virtualDom.h)('div.no-messages', 'No users loaded.'));
      }

      return result;
    }
  });
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-post-item", ["discourse/widgets/widget", "virtual-dom", "discourse-common/lib/get-url"], function (_widget, _virtualDom, _getUrl) {
  "use strict";

  (0, _widget.createWidget)('sidebar-post-item', {
    tagName: 'div.sidebar-post-item',
    html: function html(attrs) {
      var url = (0, _getUrl.default)("/t/") + attrs.slug + "/" + attrs.id;
      return [(0, _virtualDom.h)('a.item-title', {
        attributes: {
          href: url
        }
      }, attrs.title), (0, _virtualDom.h)('span.comment_count', {}, attrs.posts_count - 1) // h('span', this.attach('featured-link', {topic: attrs}))
      ];
    }
  });
});
define("discourse/plugins/discourse-sidebar-blocks/discourse/widgets/sidebar-reply-item", ["discourse/widgets/widget", "virtual-dom", "discourse/helpers/node", "discourse-common/lib/get-url"], function (_widget, _virtualDom, _node, _getUrl) {
  "use strict";

  (0, _widget.createWidget)('sidebar-reply-item', {
    tagName: 'div.sidebar-reply-item',
    html: function html(attrs) {
      var url = (0, _getUrl.default)("/t/") + attrs.topic_slug + "/" + attrs.topic_id + "/" + attrs.id;
      var limit = 125;
      var excerpt = $(attrs.cooked).text();

      if (excerpt.length > limit) {
        excerpt = $('<div>').html(attrs.cooked);
        excerpt.find("img,aside").remove();
        excerpt = excerpt.text().substring(0, limit).trim(this) + "...";
      }

      var createdAt = new Date(attrs.created_at);
      return [(0, _virtualDom.h)('span.avatar', this.attach('post-avatar', attrs)), (0, _virtualDom.h)('span.reply-date', {}, (0, _node.dateNode)(createdAt)), (0, _virtualDom.h)('span.excerpt', excerpt), (0, _virtualDom.h)('a.item-title', {
        attributes: {
          href: url
        }
      }, attrs.topic_title)];
    }
  });
});

